import { $mod as __mod, createQueryOperator } from "../../_predicates";
const $mod = createQueryOperator(__mod);
export {
  $mod
};
